import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=69515633&"
import script from "./Buscador.vue?vue&type=script&lang=js&"
export * from "./Buscador.vue?vue&type=script&lang=js&"
import style0 from "@trevoreyre/autocomplete-vue/dist/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Buscador.vue?vue&type=style&index=1&id=69515633&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports